/* eslint-disable @typescript-eslint/no-shadow */
import React, { memo } from 'react';
import IconFont from '$/components/IconFont';
import classNames from 'classnames';
import Image from '$/components/NextImage';
// import order1 from '../SingleCategoryItem/order-1.png';
import RadishStep from '../RadishStep';
import styles from './index.module.scss';

type CategoryRightsDesc = {
  title?: string;
  titleIcon?: string;
  itemCategory?: string;
  subTips?: string[];
};

type PricingBadgeTone = 'pricingBadge1' | 'pricingBadge2';

interface CategoryItemProps {
  name: string;
  nameClass?: string;
  moneySymbol: string;
  price: string;
  originalPrice?: string;
  discount?: string;
  discountTone?: PricingBadgeTone;
  operatorNode?: React.ReactNode;
  extraPriceNode?: React.ReactNode;
  monthUnit?: string;
  calcPowerIcon?: string;
  calcPowerTitle?: string;
  calcPowerRate?: string;
  showCalcPowerStep?: boolean;
  calcPowerOptions?: Array<{
    key: string;
    label: string;
    active?: boolean;
    onClick?: () => void;
  }>;
  renewNote?: string;
  productRightsDesc?: CategoryRightsDesc[];
  teamMode?: boolean;
}

/**
 * 判断权益分组是否包含可见内容，过滤接口兜底下发的空分组。
 */
function isVisibleRightsGroup(item: CategoryRightsDesc) {
  return Boolean(item?.title || item?.titleIcon || item?.subTips?.length);
}

/**
 * 渲染新版会员订阅套餐卡，卡片视觉由列表渲染顺序决定。
 */
function CategoryItem(props: CategoryItemProps) {
  const {
    name = '', price = '', discount = '', discountTone = 'pricingBadge1', moneySymbol, operatorNode, extraPriceNode, monthUnit, nameClass, originalPrice = '', calcPowerIcon = '', calcPowerTitle = '', calcPowerRate = '', showCalcPowerStep = false, calcPowerOptions = [], renewNote = '', productRightsDesc = [], teamMode = false,
  } = props;
  const visibleRightsDesc = productRightsDesc.filter(isVisibleRightsGroup);

  /**
   * 渲染新版权益单行，使用 Figma 的 12px 勾选与 18px 文本行高。
   */
  const renderRightsRow = (subTip: string) => (
    <div className={styles['rights-row']} key={subTip}>
      <IconFont name="checkV2Bold" fontSize={12} className={styles['rights-check-icon']} />
      <div className={styles['rights-row-text']}>{subTip}</div>
    </div>
  );

  /**
  * 渲染新版 product_rights_desc 分组，保留接口标题与图标能力。
  */
  const renderRightsGroup = (item: CategoryRightsDesc, index: number) => {
    const titleIconNode = item.titleIcon
      ? <Image src={item.titleIcon} width={16} height={16} alt="" />
      : null;

    return (
      // eslint-disable-next-line react/no-array-index-key
      <div className={styles['tip-section']} key={`${item.itemCategory || item.title || 'rights'}-${index}`}>
        {item.title ? (
          <div className={classNames(styles['tip-section-title'], {
            [styles['promotion-tip-section-title']]: item.itemCategory === 'limit_time_promotion',
          })}
          >
            {titleIconNode}
            <span>{item.title}</span>
          </div>
        ) : null}
        {item.subTips?.length ? (
          <div className={styles['rights-section-content']}>
            {item.subTips.map(renderRightsRow)}
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className={classNames(styles['category-item'], styles['subscription-item'], {
      [styles['team-subscription-item']]: teamMode,
    })}
    >
      {discount && (
        <div className={classNames(styles.discount, {
          [styles['discount-pricing-badge-2']]: discountTone === 'pricingBadge2',
        })}
        >
          {discount}
        </div>
      )}
      <div className={classNames(styles['category-item-name'], nameClass)}>
        <div>{name}</div>
      </div>
      <div className={styles['category-item-price-info']}>
        <div className={styles['category-item-price-symbol']}>{moneySymbol}</div>
        <div className={styles['category-item-price']}>{price}</div>
        <div className={styles['category-item-unit-text']}>{monthUnit}</div>
        {originalPrice && (
          <div className={styles['category-item-originla-price']}>
            {originalPrice}
          </div>
        )}
      </div>
      <div className={styles['renew-note']}>{renewNote}</div>
      {extraPriceNode}
      <RadishStep
        icon={calcPowerIcon}
        title={calcPowerTitle}
        rate={calcPowerRate}
        options={calcPowerOptions}
        showStep={showCalcPowerStep}
        className={classNames({ [styles['calc-power-card-with-extra']]: Boolean(extraPriceNode) })}
      />
      <div className={styles['operate-btn']}>{operatorNode}</div>
      <div className={styles['category-tips']}>
        {visibleRightsDesc.map(renderRightsGroup)}
      </div>
    </div>
  );
}
export default memo(CategoryItem);
